import type { RootState } from "store/types";

// `config` (src/reducers/config.js) unwound at the selector boundary for containers/Games
// (PLAY-5160), following store/selectors/filters.ts's shape.
export function selectGameFullscreen(state: RootState): boolean | undefined {
  return state.config.get("gameFullscreen");
}

// containers/GameCategory (PLAY-5216, Phase 1).
export function selectHideSplash(state: RootState): boolean | undefined {
  return state.config.get("hideSplash");
}

// containers/GameNavigation (PLAY-5216, Phase 1).
export function selectFiltersVisible(state: RootState): boolean | undefined {
  return state.config.get("filtersVisible");
}

// containers/LeaderBoard (PLAY-5216, Phase 2).
export function selectLocale(state: RootState): string | undefined {
  return state.config.getIn(["locale"]);
}

// containers/Category (PLAY-5216, Phase 3).
export function selectSorting(state: RootState): boolean | undefined {
  return state.config.get("sorting");
}

export function selectHost(state: RootState): string | undefined {
  return state.config.get("host");
}
